import { IFonts } from './@types';

const fontsConfig: IFonts = {
  families: {
    primary: 'Proxima Nova',
    secondary: 'Gotham Rounded',
    calendar: 'Helvetica Neue',
  },
  sizes: {
    small: 10,
    smallL: 12,
    defaultS: 14,
    default: 16,
    defaultL: 18,
    medium: 20,
    mediumL: 24,
    large: 32,
    largeS: 40,
    largeL: 48,
    largeXL: 64,
  },
  weights: {
    Thin: 100,
    ExtraLigh: 200,
    Light: 300,
    Normal: 400,
    Medium: 500,
    SemiBold: 600,
    Bold: 700,
    ExtraBold: 800,
    Black: 900,
  },
};

export default fontsConfig;
